import { unsafeCSS, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host {\n  display: block;\n}\n:host .chc-c-product-card__footer {\n  margin-top: var(--leaf-spacing-16);\n  padding: 0 var(--leaf-spacing-32);\n}";
const _CHCProductCardFooter = class _CHCProductCardFooter extends e(LeafElement) {
  render() {
    const componentClassName = {
      "chc-c-product-card__footer": true
    };
    return html`<div class=${classMap(componentClassName)}>
      <slot></slot>
    </div>`;
  }
};
_CHCProductCardFooter.styles = unsafeCSS(styles);
let CHCProductCardFooter = _CHCProductCardFooter;
export {
  CHCProductCardFooter
};
//# sourceMappingURL=product-card-footer.component.js.map
